
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./windows-iana.cjs.production.min.js')
} else {
  module.exports = require('./windows-iana.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/windows-iana/dist/index.js
// module id = 1255
// module chunks = 0